import { PaymentStep } from "@/types/pages/form";
import { useState } from "react";

interface UsePaymentFormResponse {
  step: PaymentStep;
  nextStep: (step?: PaymentStep) => void;
  shippingAmount: number;
  setShippingAmount: (value: number) => void;
}

export const usePaymentForm = (): UsePaymentFormResponse => {
  const [step, setStep] = useState<PaymentStep>("account");
  const [shippingAmount, setShippingAmount] = useState(0);

  const nextStep = (targetStep?: PaymentStep) => {
    if (targetStep) {
      setStep(targetStep);
      return;
    }

    if (step === "account") {
      setStep("shipping");
    } else if (step === "shipping") {
      setStep("payment");
    }
  };

  return {
    step,
    nextStep,
    shippingAmount,
    setShippingAmount,
  };
};
